<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="custName"
      placeholder="输入客户进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="{name: 'B2BCustomerBillDetailList', params: { item }}"
      >
        <div class="weui-cell__bd">
          <p>{{item.custName}}</p>
          <!-- <p class="list-item-muted">{{item.currency}}</p> -->
        </div>
        <div class="weui-cell__ft">
          <p>{{item.currency}}</p>
          <!-- <span
            class="list-item-status"
            :class="{'warning':item.pi_status!='已审核'}"
          >{{item.pi_status}}</span> -->
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}家</label>
      <!-- <em class="list-footer__value" v-format="'¥#,##0.00'">{{getTotal('pi_total')}}</em> -->
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  data() {
    return {
      items: [],
      listUrl: "/api/purchase/purchaseBill/customerBillList",
      filters: [
        {
          type: "date",
          // name: "pi_date"
        }
      ]
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.onSearch();
    });
  },
  methods: {
    onSearch() {
      var me = this

      let filterBar = me.$refs.filterBar
      let dateFilter = me.$refs.filterBar.parsedFilters[0]
      let period = dateFilter.fn(dateFilter.value, dateFilter, filterBar).value.split(',')
      let fromDate = period[0].split(/-|\s|:/)
      let endDate = period[1].split(/-|\s|:/)

      let params
      params = {
        // pageNumber: 1,
        // pageSize: 16,
        startTime: `${fromDate[0]}-${fromDate[1]}-${fromDate[2]} ${fromDate[3]}:${fromDate[4]}:${fromDate[5]}`,
        endTime: `${endDate[0]}-${endDate[1]}-${endDate[2]} ${endDate[3]}:${endDate[4]}:${endDate[5]}`,
        // page: 1,
        // start: 0,
        limit: 999999,
      }

      me.$loading({
        url: me.listUrl,
        params
      }).then(function (res) {
        if (res.success) {
          me.items = res.data || []
        } else {
          me.$router.push({
            name: "Error",
            params: res
          });
        }
      });
    }
  }

};
</script>